import React from "react";
import { Modal, ShadowContent } from "../../atoms";

/** Displays a Notification's HTML */
export const InAppNotificationViewModal = ({
  notificationHtml,
  open,
  handleClose,
  asModal = true,
}) => {
  /* Avoid TailwindCSS class names conflict
   * \b : only match when starting a "word" (ie. don't match "ship-specific")
   */
  const reportContent = notificationHtml
    .replace(/\bp-/g, "inapp_p-")
    .replace(/\bpl-/g, "inapp_pl-")
    .replace(/\bpr-/g, "inapp_pr-")
    .replace(/\bpt-/g, "inapp_pt-")
    .replace(/\bpb-/g, "inapp_pb-");

  // increase email templates "max-width" for inapp preview
  //.replaceAll("600px", "640px")
  //.replaceAll("598px", "640px");

  const content = (
    <div className="bg-canvas w-full h-full mx-auto relative">
      <ShadowContent
        html={reportContent}
        title="Email Preview"
        style={{
          maxWidth: "100%",
          width: "600px",
          height: "100%",
          border: "none",
          overflowX: "hidden",
        }}
      ></ShadowContent>
    </div>
  );

  if (asModal)
    return (
      <Modal size="email" open={open} handleClose={handleClose} primary>
        {content}
      </Modal>
    );
  return content;
};
